import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PageHeader from '../../../shared/PageHeader'
import { MdBatchPrediction } from 'react-icons/md'
import CustomTabs from '../../../shared/CustomTabs'
import BulkClaimsBatchesTab from './BulkClaimsBatchesTab'
import AuditApprovalBatchesTab from './AuditApprovalBatchesTab'
import AutoCorrectionBatchesTab from './AutoCorrectionBatchesTab'

function BulkClaimsBatches() {
  const { t } = useTranslation()
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const tabs = [
    {
      name: t('Bulk Claims Batches'),
      content: <BulkClaimsBatchesTab />
    },
    {
      name: t('Audit Approval Batches'),
      content: <AuditApprovalBatchesTab />
    },
    {
      name: t('Auto-Correction Batches'),
      content: <AutoCorrectionBatchesTab />
    }
  ]

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <CustomTabs
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
      />
    </div>
  )
}

export default BulkClaimsBatches
